<script>
    import {API_URL} from "../../../env";
    import {onMount} from "svelte";
    import {querystring} from "svelte-spa-router";
    import Loading from "../../placeholders/ProductsLoading.svelte";
    import NotFound from "../../placeholders/NotFound.svelte";
    import {addAlert} from "../../js/alert";

    $: state = "loading"
    let form = {
        token: null,
        newPassword: "",
        repeatNewPassword: ""
    }
    let bad = {
        newPassword: false,
        repeatNewPassword: false,
    }

    onMount(() => {
        const urlParams = new URLSearchParams($querystring)

        if (!urlParams.has("t")) {
            return state = "no-token"
        }

        form.token = urlParams.get("t")

        if (form.token.length === 0) {
            return state = "no-token"
        }

        state = "form-filling"
    })



    let isFetching = false
    async function handleChange() {
        if (isFetching) return;
        isFetching = true

        /* Check form */
        let isBad = false
        bad = {
            newPassword: false,
            repeatNewPassword: false
        }

        if (form.newPassword.length < 8 && form.newPassword.length > 64) {
            bad.newPassword = true
            isBad = true
        }
        if (form.repeatNewPassword.length < 8 && form.newPassword !== form.repeatNewPassword) {
            bad.newPassword = true
            isBad = true
        }

        if (isBad) {
            return isFetching = false;
        }
        /* ********** */

        let body = {...form}

        delete body.repeatNewPassword

        const res = await fetch(API_URL+'/users/changeForgottenPassword', {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        })

        if (!res.ok) {
            addAlert("danger", "Chyba", "Nastala chyba pri obnove hesla.")
            isFetching = false
            return;
        }

        state = "done"
    }
</script>

<section class="error-page">
    <div class="row">
        <div class="col-12">
            {#if state === "form-filling"}
            <!-- TODO TADY UDĚLAT FORMULÁŘ -->

                <form on:submit|preventDefault={handleChange}>
                    <input bind:value={form.newPassword} placeholder="Nové heslo" name="newPassword">
                    <input bind:value={form.repeatNewPassword} placeholder="Nové heslo znovu" name="repeatNewPassword">
                    <div class="account-strength">
                        <span>SÍLA HESLA</span>
<!--                        <div class="strength-bar" style="&#45;&#45;progress-width: {newPasswordStrength.progressBar}%; &#45;&#45;progress-hex: {newPasswordStrength.progressBarColor};"></div>-->
<!--                        <p>{newPasswordStrength.text}</p>-->
                    </div>
                    <button>
                        Odeslat
                        {#if isFetching}
                            &nbsp;&nbsp;<i class="fa-solid fa-spinner-third fa-spin"></i>
                        {/if}
                    </button>
                </form>

            <!-- TODO TADY KONČÍ FORMULÁŘ-->
            {:else if state === "loading"}
                <Loading title = "Overujem predpoklady..."/>
            {:else if state === "done"}
                <div class="loading-page">
                    <i class="fa-regular fa-circle-check"></i>
                    <h3>Heslo úspešne obnovené.</h3>
                    <p class="margin-top">Teraz sa môžete s novým heslom prihlásiť.</p>
                </div>
            {:else if state === "no-token"}
                <NotFound title="Nie je možné zmeniť žiadne zabudnuté heslo, chýba overovací token."/>
            <!--{:else}-->
            <!--    <Error-->
            <!--            title="Niekde nastala chyba."-->
            <!--    />-->
            {/if}
        </div>
    </div>
</section>

<style>
    .margin-top {
        margin-top: 0.5rem;
    }
</style>